/**
 * Classe représentant une électrode du capteur Muse
 * @module ElectrodeMuse
 */

import {fft, powerByBand} from "@neurosity/pipes";
import {fromEvent} from "rxjs";
var events = require("events");

export default class ElectrodeMuse {
    /** Représenter le capteur bluetooth
     * @construtor
     * @param {string} aChannelName - identifiant de la chaîne de l'électrode
     */
    constructor(aChannelName) {
        this.channelName = aChannelName ;
        this.buffer = [] ;
        this.smoothAlphaMetrics = 0 ;
        this.smoothThetaMetrics = 0 ;
        this.smoothBetaMetrics = 0 ;
        this.smoothDeltaMetrics = 0 ;
        this.smoothGammaMetrics = 0 ;
        this.emitter = new events.EventEmitter() ;
        this.eeg = fromEvent(this.emitter, 'data').pipe(fft({bins: 256}), powerByBand()).subscribe(powerByPower => this.displayPowerBand(powerByPower)) ;
        this.valeursBrutes = [] ;
        this.arrayOriginValues = [] ;
    }

    /** Gestion de l'évènement
     * @constructor
     * @param {data} data - données reçues de l'électrode.
     * @param {string} channel - identifiant de la chaîne de l'électrode
     */
    emitterEmit(data, channel) {
        this.emitter.emit('data', data);
    }

    /** Gestion de l'évenement de l'électrode. Récupérer les valeurs brutes afin d'appliquer les différentes transformations
     * @function
     * @param {event} event - Evenement reçu par le gestionnaire
     */
    handleCharacteristicValueChanged = (event) => {
        let value = event.target.value;
        let samples = new Uint8Array(value.buffer);
        const samples12Bit = [];

        for (let i = 2; i < samples.length; i++) {
            if ((i - 2) % 3 === 0) {
                samples12Bit.push(samples[i + 2] << 4 | samples[i + 3] >> 4);
            } else {
                samples12Bit.push((samples[i + 2] & 0xf) << 8 | samples[i + 3]);
                i++;
            }
        }

        samples12Bit.map((n) => this.buffer.push(0.48828125 * (n - 0x800))); // Valeur à mettre dans le CSV
        this.valeursBrutes = samples12Bit;

        if (this.buffer.length >= 256) {
            var chunk = this.buffer.slice(0, 256);
            this.buffer = this.buffer.slice(128);
            const data = {
                data: [chunk],
                info: {
                    samplingRate: 256,
                    startTime: 0,
                    channelNames: [this.channelName]
                }
            }
            this.emitterEmit(data, this.channelName);
        }
    };


    /** Tranformer les valerus brutes en valeurs exploitables (Alpha, Theta, Delta, Beta, Gamma). Le lissage des données se réalise au sein de cette méthode. Toutes ces valeurs sont issues de chaque électrode.
     * @function
     * @param {PSD} PSDs - Différentes densités spectrales des signaux captés.
     */
    displayPowerBand(PSDs) {

        let _delta = PSDs.delta[0];
        let _theta = PSDs.theta[0];
        let _alpha = PSDs.alpha[0];
        let _beta = PSDs.beta[0];
        let _gamma = PSDs.gamma[0];

        let _total = _delta + _theta + _alpha + _beta + _gamma;

        if (_total !== 0)
        {
            this.smoothAlphaMetrics = .9 * this.smoothAlphaMetrics + .1 * _alpha / _total ;// chill
            this.smoothDeltaMetrics = .9 * this.smoothDeltaMetrics + .1 * _delta / _total ;// chill
            this.smoothBetaMetrics = .9 * this.smoothBetaMetrics + .1 * _beta / _total ;// chill
            this.smoothThetaMetrics = .9 * this.smoothThetaMetrics + .1 * _theta / _total ;// chill
            this.smoothGammaMetrics = .9 * this.smoothGammaMetrics + .1 * _gamma / _total ;// chill
        }
    }
}